// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swal2-cancel,.swal2-confirm{border-radius:12px!important}", ""]);
// Exports
module.exports = exports;
